import React from "react"
import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell";

// const debug = "FieldItemModelCalculatedSpentEstimate_TableCell"
const debug = false

type State = {
    isHovered   : boolean
    showPopover : boolean
}

export default function FieldItemModelCalculatedSpentEstimate_TableCell(props: FieldTableCellProps){

    const classes = Classes("cell-flex ui5-txt-less-important-small", props.column.id)

    let value = 0

    if (props.listItem.isCollapsed && props.listItem.estimated.total && props.listItem.estimated.total != props.listItem.estimated.own) {
        value = Math.floor(props.listItem.reported.total * 100 / props.listItem.estimated.total)
    } else if (props.listItem.estimated.own) {
        value = Math.floor(props.listItem.reported.own * 100 / props.listItem.estimated.own)
    } else {
        //  ????
    }

    const excess = value > 100
    const progressLine = excess ? Math.floor(100 * (100 / value)) : value;
    const progressClasses = Classes("ui5-progress", "in-ui5-field", {
        'excess-v2': excess,
    });

    const style = getTableCellStyle(props)

    return (
        <React.Fragment>
            <div className={classes} style={getTableCellStyle(props)}>
                {!!value && (
                    <div className={Classes(progressClasses, style.width > 100 ? "" : "flex-row-center-center")}>
                        {style.width > 100 && (
                            <div className="progress-bg">
                                <div className="progress-line" style={{width: '{0}%'.f(progressLine)}}/>
                            </div>
                        )}

                        <div className="progress-label ui5-txt-less-important-small percentage txt-truncate">{"{0}%".f(value)}</div>
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}



